module.exports = __webpack_public_path__ + "img/illo_sm_employees_3_3554528_c_9_f_99_ede_44_e_2797833410_a_520.ceccbcbb.svg";